import React, { useState, useEffect } from 'react';
import { SimulatorOfferModel, RiderPackageModel, VehicleDataModel, YesNo } from './models/superbit-api-models'
import { StatOptions } from 'fs';
// import moment from 'moment';
import { SimulatorModel, SimulatorData } from './models/SimulatorModel'
import { AyalonOffer } from './offers/_AyalonOffer'
import { HarelOffer } from './offers/_HarelOffer'
import { FnxOffer } from './offers/_FnxOffer'
import { MigdalOffer } from './offers/_MigdalOffer'
import { ShlomoOffer } from './offers/_ShlomoOffer'
import { OtherOffer } from './offers/_OtherOffer'
import { OfferRider } from './offers/_OfferRider'
import  LeadOffer from './leads/_LeadOffer'

// import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { SaveOfferButton } from './simulator/_SaveOfferButton'
import { OfferProductionModel } from './models/OfferProductionModel';
import PleaseWaitLayer from './components/_PleaseWaitLayer';
import NewLeadAndProduction from './components/NewLeadAndProduction';
// import { createBrowserHistory } from 'history';

type Props = {
    offer: SimulatorOfferModel | null;
    riders: RiderPackageModel[];
    showOfferLog: any;
    getSimulatorData: any;
    onChanged: any;
    onProductionClick: any;
    selectedLeadId?: string;
    history?: any
    lead: any;

};
type State = {
    open: boolean;
    offer: SimulatorOfferModel | null;
    riders: RiderPackageModel[];
    ridersSum: number;
    totalSum: number;
    recalcOffer: boolean;
    saveActive: boolean;
    saveButtonClicked: boolean;
    savedOffer: any;
    loading: boolean;
};

interface HTMLContent {
    __html: string;
}

export class Offer extends React.Component<Props, State> {

    offerProductionModel: OfferProductionModel = new OfferProductionModel();

    constructor(props: any) {
        super(props);
        this.state = {
            open: false,
            offer: this.props.offer,
            riders: [],
            ridersSum: 0,
            totalSum: 0,
            recalcOffer: false,
            saveActive: true,
            saveButtonClicked: false,
            savedOffer: null,
            loading: false,
        };
        // this.onChanged = this.onChanged.bind(this);
    }

    decodeHtmlEntities(html: string): string {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.value;
    }



    async componentDidMount() {
        //console.log('props', this.props);
        this.setState({
            riders: this.props.riders
        }, () => {
            this.setState({ ridersSum: this.calcRiders() });
            this.calculateOfferTotal();
            // try {
            //     if (this.state.offer && this.state.offer.id) {
            //         this.offerProductionModel.getOpenProduction(this.state.offer.id).then((data) => {
            //             if (data) {
            //                 this.setState({ savedOffer: data })
            //             } else {
            //                 this.setState({ savedOffer: null })
            //             }
            //         })
            //     }
            // } catch (error) {
            //     console.log('error', error)
            //     this.setState({ savedOffer: null })
            // }
        });
    }



    async componentDidUpdate(prevProps: Props) {
        if (prevProps.riders !== this.props.riders) {
            if (this.state.riders.length == 0) {
                this.setState({
                    riders: this.props.riders
                }, () => {
                    this.setState({ ridersSum: this.calcRiders() }, () => {
                        this.calculateOfferTotal();
                    });
                });
            }
        }
    };

    calculateOfferTotal = () => {
        let total = 0;
        if (this.state.offer) {
            if (this.state.offer.cascoPremium) {
                total += this.state.offer.cascoPremium;
            }
            if (this.state.offer.compulsoryPremium) {
                total += this.state.offer.compulsoryPremium;
            }
            // if (this.state.ridersSum) {
            // }
            const ridersSum = this.calcRiders();
            total += ridersSum;
        }
        this.setState({ totalSum: total });
    }

    toggleOpen = async (event: any) => {
        const open = this.state.open;
        console.log('open', open)
        if (!open) {
            try {
                if (this.state.offer && this.state.offer.id) {
                    this.offerProductionModel.getOpenProduction(this.state.offer.id).then((data) => {
                        if (data) {
                            this.setState({ savedOffer: data })
                        } else {
                            this.setState({ savedOffer: null })
                        }
                    }).catch((error) => {
                        console.log('error', error)
                        this.setState({ savedOffer: null })
                    })
                }
            } catch (error) {
                console.log('error', error)
                this.setState({ savedOffer: null })
            }
        }
        this.setState({ open: !open });
    }

    showLog = async (event: any) => {
        if (this.props.offer != null) {
            this.props.showOfferLog(this.props.offer.messageData);
        }

    }

    updateRider = async (rider: RiderPackageModel) => {

        var riders = this.state.riders;
        /*  var state = this.state;
        var prop = this.props;
        var priders = this.props.riders; */
        //Find index of specific object using findIndex method.    
        var objIndex = riders.findIndex((obj => obj.id == rider.id));
        //console.log('recalcOffer rider', riders, rider)
        riders[objIndex] = rider;
        await this.setState({ riders: riders }, async () => {

            this.props.onChanged(this.state.offer);
        });


        //this.props.onRiderChanged(this.state.riders);
        this.setState({ ridersSum: this.calcRiders() }, () => {
            this.calculateOfferTotal();
        });
    }

    onOfferChanged = async (data: SimulatorOfferModel) => {

        await this.setState({ offer: data }, async () => {
            this.props.onChanged(this.state.offer);
            await this.disableSave();
        });

        // this.props.onChanged(event);
        //console.log(this.state.offer);
    }

    openProduction = async (res: any) => {
        let offerTemp = this.state.offer
        if (offerTemp) {
            // check if got offer id after saving
            if (res != '') {
                // const existingOffer = await new OfferProductionModel().simulatorOpenGetProduction(res);
                // if(existingOffer && existingOffer.id){
                //     // open existing production
                //     this.props.onProductionClick(existingOffer, this.state.riders);
                //     return;
                // }
                offerTemp.id = res;
                this.setState({ offer: offerTemp }, () => {
                    this.props.onProductionClick(this.state.offer, this.state.riders);
                })
            } else {
                console.log('111', 111)
                this.props.onProductionClick(this.state.offer, this.state.riders);
            }
        }
    }

    disableSave = async () => {

        await this.setState({ saveActive: false });
    }

    checkDate = (date: any) => {
        return new Date('1974-01-01') < new Date(date) ? date : new Date();
    }

    recalcOffer = async (event: any) => {
        if (this.state.offer != null) {

            var data = this.props.getSimulatorData();

            await this.setState({ recalcOffer: true });

            data.riders = data.riders.filter((r: RiderPackageModel) => r.autoActive == 1);
            //   //console.log('recalcOffer data.riders', data.riders)
            //   const riders: RiderPackageModel[] =  this.state.riders.filter((r: RiderPackageModel) => r.autoActive == YesNo._0);
            //   //console.log('recalcOffer riders', riders)
            //data.riders = [] as RiderPackageModel[];
            var offer = this.state.offer;
            offer.endDate = this.checkDate(offer.endDate);
            offer.createdDate = this.checkDate(offer.createdDate);
            offer.updatedDate = this.checkDate(offer.updatedDate);
            if (offer.lead) {
                offer.lead.createdDate = this.checkDate(offer.lead.createdDate);
                offer.lead.updatedDate = this.checkDate(offer.lead.updatedDate);
                offer.lead.identityCardIssueDate = this.checkDate(offer.lead.identityCardIssueDate);
                offer.lead.simulatorOfferStageDate = this.checkDate(offer.lead.simulatorOfferStageDate);
                if (data.entryToRoadDate && offer.lead.vehicle) {
                    offer.lead.vehicle.entryToRoadDate = data.entryToRoadDate
                    // //console.log('state', this.state)
                }
            }
            data.recalcOffer = offer;

            data.recalcOffer.activeDiscounts = offer.activeDiscounts;
            data.recalcOffer.activeDiscounts = data.recalcOffer.activeDiscounts ? data.recalcOffer.activeDiscounts.filter((x: any) => x.autoActive == 0) : [];
            //console.log('recalcOffer sendData', data)
            var retData = await new SimulatorModel().recalcSimulator(data);
            if (retData && retData.length > 0) {
                var offer = this.state.offer;
                await this.setState({ offer: null });
                //console.log('recalcOffer retData', retData[0])

                offer.activeDiscounts = retData[0].activeDiscounts;
                offer.cascoPremium = retData[0].cascoPremium;
                offer.compulsoryPremium = retData[0].compulsoryPremium;
                offer.messageData = retData[0].messageData;
                await this.setState({ offer: offer });
                await this.setState({ recalcOffer: false });
                await this.setState({ saveActive: true });
            }

            this.calculateOfferTotal();
        }
    }

    calcRiders = () => {
        var riders = 0;
        if (this.state != null && this.state.riders != null) {
            var activeRiders = this.state.riders.filter(x => x.autoActive == 0);
            if (activeRiders != null && activeRiders.length > 0) {

                var allRiders = activeRiders.map(x => x.recommendedCost).reduce(function (a, b) {
                    return (a != null && b != null) ? (a + b) : 0;
                }, 0);



                if (allRiders != null) {
                    riders = allRiders;

                }
            }
        }
        return riders;
    }

    saveOffer = async (event: any) => {
        if (this.state.offer != null) {
            
            // this.setState({ loading: true })
            var data = this.props.getSimulatorData();

            // var riders = this.state.riders.filter(x=>x.autoActive==0).map(x=>x.id);
            // data.riders = data.riders.filter((item:RiderPackageModel) => riders.includes(item.id));

            var ridersIds = this.state.riders.filter(x => x.autoActive == 0).map(x => x.id);
            var riders = this.state.riders.filter(x => x.autoActive == 0);


            data.riders = data.riders.filter((item: RiderPackageModel) => ridersIds.includes(item.id)).map((x: RiderPackageModel) => {
                var rider = riders.find(r => r.id === x.id); // Corrected to find the matching rider by id
                if (rider) {
                    x.recommendedCost = rider.recommendedCost;
                }
                return x;
            });

            var offer = this.state.offer;
            data.recalcOffer = offer;
            data.vehicle = new VehicleDataModel();
            data.vehicle.vehicleSubModelId = data.vehicleSubModelId;
            if (this.props.selectedLeadId && this.props.selectedLeadId !== '')
                data.lead = {
                    id: this.props.selectedLeadId
                }
            // this.props.selectedLeadId
            
            let res = await new SimulatorModel().saveSimulator(data);
            console.log('res', res)
            // this.setState({ loading: false })
            // this.openProduction(res)
            await this.setState({ saveButtonClicked: true });
            //await this.setState({saveButtonClicked:false});
            return res;
        }
    }
    // saveOfferAndNavigateToLead = (e: any) => {
    //     this.saveOffer(e)
    // }


    saveOfferAndShowProduction = async (e: any) => {
        this.setState({ loading: true })
        let res = await this.saveOffer(e)
        this.openProduction(res)
        this.setState({ loading: false })

    }


    isOfferIdValid = async () => {
        if (this.state.offer && this.state.offer.id) {
            return await this.offerProductionModel.getOpenProduction(this.state.offer.id);
        }
    }

    renderInsuranceCompany = () => {

        if (this.state.offer != null && this.state.offer.insuranceCompany != null) {
            //console.log("renderInsuranceCompany"+this.state.offer.insuranceCompany.name);
            switch (this.state.offer.insuranceCompany.name) {
                case "איילון":
                    return (<>
                        <AyalonOffer offer={this.state.offer} onChanged={this.onOfferChanged} />
                    </>);
                case "הראל":
                    return (<HarelOffer offer={this.state.offer} onChanged={this.onOfferChanged} />);
                case "הפניקס":
                    return (<FnxOffer offer={this.state.offer} onChanged={this.onOfferChanged} />);
                case "מגדל":
                    return (<MigdalOffer offer={this.state.offer} onChanged={this.onOfferChanged} />);
                case "שלמה":
                    return (<ShlomoOffer offer={this.state.offer} onChanged={this.onOfferChanged} />);
                default:
                    return (<OtherOffer offer={this.state.offer} onChanged={this.onOfferChanged} />);

            }

        }
        //console.log("renderInsuranceCompany non name");
        return (<AyalonOffer offer={this.state.offer} onChanged={this.onOfferChanged} />);
    }

    getIcon = () => {
        try {
            if (this.state.offer != null && this.state.offer.insuranceCompany != null) {
                switch (this.state.offer.insuranceCompany.name) {
                    case "איילון":
                        return "ayalon.svg";
                    case "אנקור":
                        return "ankor.png";
                    case "הראל":
                        return "harel.svg";
                    case "הפניקס":
                        return "fenix.svg";
                    case "מגדל":
                        return "migdal.svg";
                    case "שלמה":
                        return "shlomo.svg";
                    case "שומרה":
                        return "shomera.svg";
                    case "כלל":
                        return "klal.svg";
                    case "חקלאי":
                        return "haklay.svg";
                    case "הכשרת הישוב":
                        return "hachshara.svg";
                    case "מנורה":
                        return "menora.svg";
                }
            }
        } catch (e) {
            console.log(e);
            if (this.state.offer != null && this.state.offer.insuranceCompany != null) {
                console.log('this.state.offer.insuranceCompany.name', this.state.offer.insuranceCompany.name)
            }
            
                
            return "ayalon.svg";
        }
        
                
        return "ayalon.svg";
    }


    render() {


        return (
            <>
                <div>
                    <div className={this.state.open ? "data-card flex-space-between pointer open " : "data-card flex-space-between pointer"}>
                        {this.state.offer != null ? (<>
                            <div className="data-card-body flex-space-between">
                                <div className="cell icon-cell">
                                    <div className={this.state.offer.star ? "icon star selected" : "icon star"}></div>
                                </div>
                                <div className="cell companyNameCell">
                                    <div className=" cell-value">
                                        {/* {this.state.offer.insuranceCompany != null ? this.state.offer.insuranceCompany.name : ""} */}
                                        {
                                            // make icon with svg image as company svg logo
                                            this.state.offer.insuranceCompany != null ? <img src={require(`./assets/images/icons/simulator/${this.getIcon()}`)} alt={''} /> : ""}
                                    </div>
                                </div>
                                <div className="cell nameCell">
                                    <div className=" cell-value">
                                        <span>{this.state.offer.routeId}</span>
                                        <span>{this.state.offer.routeComment != null && this.state.offer.routeComment.length > 0 ? " - " + this.state.offer.routeComment : ""}</span>
                                        <span>{this.state.offer.collectiveId != null && this.state.offer.collectiveId > 0 ? " קולקטיב: " + this.state.offer.collectiveId : ""}</span>
                                    </div>
                                </div>
                                <div className="cell long desktop-only notes">
                                    <div className="description cell-value">
                                        {this.state.offer.comments != null ? this.decodeHtmlEntities(this.state.offer.comments.join(", ").replace(/<[^>]*>?/gm, '')) : ""}
                                    </div>
                                </div>
                                <div className="cell desktop-only price">
                                    <div className="description cell-value">
                                        {this.state.offer.cascoPremium != null ? this.state.offer.cascoPremium + " ש\"ח" : ""}
                                    </div>
                                </div>
                                <div className="cell desktop-only price">
                                    <div className="description cell-value">
                                        {this.state.offer.compulsoryPremium != null ? this.state.offer.compulsoryPremium + " ש\"ח" : ""}

                                    </div>
                                </div>
                                <div className="cell desktop-only price">
                                    <div className="description cell-value">
                                        {this.state.ridersSum != null ? this.state.ridersSum + " ש\"ח" : ""}
                                    </div>
                                </div>
                                <div className="cell price">
                                    <div className="description cell-value">
                                        {this.state.totalSum} ש"ח
                                    </div>
                                </div>
                                {/*  <div className="cell">
                        <div className="description cell-value">
                            {this.props.offer.sequenceId}
                        </div>
                    </div> */}
                            </div>
                            <div className="action">
                                <div className="icon left-arrow" onClick={(e: any) => this.toggleOpen(e)} ></div>
                            </div>
                        </>
                        ) : (
                            <div></div>
                        )}
                    </div>
                   
                    <div className="data-card-full-details">
                        <div className="form-table flex-space-between flex-top">
                            <div className="form-table-cell right-side">
                                {this.renderInsuranceCompany()}
                                {/* {<AyalonOffer offer={this.state.offer} onChanged={this.onOfferChanged} />} */}
                            </div>
                            <div className="form-table-cell left-side">
                                <div className="title-row flex-space-between flex-centered">
                                    <div className="title">
                                        תוספות
                                    </div>
                                </div>
                                <div className="form-table-row flex-space-between flex-centered">
                                    <div className="form-table-column">
                                        <div className="title">
                                            חבילה
                                        </div>

                                    </div>
                                    <div className="form-table-column">
                                        <div className="title">
                                            עלות
                                        </div>

                                    </div>
                                </div>
                                {this.props.riders.length > 0 ? this.props.riders.map((rider: RiderPackageModel) => {
                                    return (
                                        <>
                                            <OfferRider checked={this.state.offer?.riders && this.state.offer.riders.filter(x => x.riderPackageId && x.riderPackageId == rider.id).length > 0}
                                            recommendedCost={this.state.offer?.riders && this.state.offer.riders.filter(x => x.riderPackageId && x.riderPackageId == rider.id).length > 0 ? this.state.offer.riders.filter(x => x.riderPackageId && x.riderPackageId == rider.id)[0].price : undefined} 
                                            rider={rider} onChanged={this.updateRider}></OfferRider>
                                        </>
                                    )
                                }) : ""}
                            </div>
                        </div>
                        <div className="note">
                            <div className="title">
                                הערות
                            </div>
                            <div className="description">
                                {this.state.offer != null && this.state.offer.comments != null && this.state.offer.comments.length > 0 ? this.state.offer.comments.map((comment: string) => {
                                    return (
                                        <>
                                            <div className='right-align message-text' dangerouslySetInnerHTML={{ __html: comment }}></div>
                                        </>
                                    )
                                }) : ""}
                            </div>
                        </div>
                        <div className="note">
                            <div className="title">
                                תנאים וכיסויים
                            </div>

                            <div className="description">
                                {this.state.offer && this.state.offer.temsAndCovers ? (
                                    <div
                                        className="right-align message-text"
                                        dangerouslySetInnerHTML={{ __html: this.state.offer.temsAndCovers }}
                                    ></div>
                                ) : (
                                    ""
                                )}
                            </div>




                        </div>
                        <div className="data-card-buttons-bottom-row flex-centered flex-justify-center">

                            {
                                this.props.selectedLeadId && this.props.selectedLeadId !== '' && this.state.saveActive == true &&
                                this.state.saveButtonClicked === false && ( // Conditionally render the button only if showButton is true
                                    <SaveOfferButton saveOfferAndShowProduction={this.saveOfferAndShowProduction} onClick={this.saveOffer} leadId={this.props.selectedLeadId} 
                                    licenseNumber={this.props.lead.vehicle && this.props.lead.vehicle.licenseNumber && this.props.lead.vehicle.licenseNumber.length > 0 ? this.props.lead.vehicle.licenseNumber : ""}
                                    ></SaveOfferButton>
                                )
                            }


                            <button onClick={(e: any) => this.recalcOffer(e)} className="button white data-card-action">
                                חשב מחדש
                                <img src={require("./assets/images/loading.gif")} className={this.state.recalcOffer != null && this.state.recalcOffer ? "loadingGif" : "hide"} />
                            </button>

                            <button onClick={(e: any) => this.showLog(e)} className="button white data-card-action">
                                הצג לוג
                            </button>

                            {this.props.selectedLeadId === '' &&
                                <NewLeadAndProduction
                                    // newLeadAction={() => this.newLead()}  
                                    onClick={this.saveOffer}
                                    leadId={this.props.selectedLeadId}
                                    offer={this.state.offer}
                                    riders={this.state.riders}
                                    getSimulatorData={this.props.getSimulatorData}

                                />
                            }
                        </div>
                    </div>

                </div>
                {
                    this.state.loading && (
                        <PleaseWaitLayer />
                    )}
            </>
        );
    }
}
